import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const I_AM = ["Organizer", "Club Secretary", "Individual", "Politician", "Govt Official", "Others"] as const;
const PROGRAM_TYPES = [
  "Wedding Ceremony", "Reception", "Club Program", "Cultural Program",
  "Corporate Event", "Political Event", "Government Event",
  "Private Function", "Musical Night", "Others",
] as const;

const enquirySchema = z.object({
  name: z.string().trim().min(2).max(100),
  email: z.string().trim().email().max(255),
  mobile: z.string().trim().regex(/^[6-9]\d{9}$/, "Enter a valid 10-digit Indian mobile"),
  event_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().or(z.literal("")),
  program_type: z.enum(PROGRAM_TYPES),
  state: z.string().trim().min(2).max(100),
  district: z.string().trim().min(2).max(100),
  city: z.string().trim().min(1).max(100),
  area: z.string().trim().min(1).max(200),
  pincode: z.string().regex(/^\d{6}$/),
  i_am: z.enum(I_AM),
  message: z.string().trim().max(1000).optional().or(z.literal("")),
});

export const submitEnquiry = createServerFn({ method: "POST" })
  .inputValidator((input) => enquirySchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const payload = {
      ...data,
      event_date: data.event_date || null,
      message: data.message || null,
    };
    const { error } = await supabaseAdmin.from("enquiries").insert(payload);
    if (error) { console.error("submitEnquiry:", error); throw new Error("Could not submit enquiry. Please try again."); }

    // Best-effort confirmation email — never fail the request on email errors.
    try {
      const { sendTemplateEmail } = await import("@/lib/email/send-internal.server");
      await sendTemplateEmail({
        templateName: "enquiry-confirmation",
        recipientEmail: data.email,
        templateData: {
          name: data.name,
          program_type: data.program_type,
          event_date: data.event_date || null,
          city: data.city,
          state: data.state,
          mobile: data.mobile,
        },
      });
    } catch (e) {
      console.error("enquiry confirmation email failed:", e);
    }

    return { ok: true };
  });
